import { motion } from 'framer-motion';

import { principles } from '@marketing/data/principles';
import { PrincipleIcon } from '@marketing/illustrations/PrincipleIcon';
import { fadeUp, revealOnView, stagger } from '@marketing/motion/variants';

// ============================================================
// PrinciplesGrid — 7 princípios não-negociáveis
// ============================================================

export function PrinciplesGrid() {
  return (
    <section
      id="principios"
      className="lume-section lume-section--alt"
      aria-labelledby="principles-title"
    >
      <div className="lume-container">
        <motion.header
          {...revealOnView}
          variants={stagger(0.08)}
          className="lume-stack lume-stack-md"
          style={{ marginBottom: 'clamp(2rem, 4vw, 3rem)', maxWidth: '52rem' }}
        >
          <motion.p variants={fadeUp} className="lume-eyebrow">Princípios</motion.p>
          <motion.h2 variants={fadeUp} id="principles-title" className="lume-h2 lume-text-balance">
            Sete pilares não-negociáveis
          </motion.h2>
          <motion.p variants={fadeUp} className="lume-body-lg lume-text-pretty">
            Estes princípios têm precedência sobre qualquer otimização técnica, prazo ou economia.
            Eles são a fonte de resolução de conflitos do programa.
          </motion.p>
        </motion.header>

        <motion.ol
          {...revealOnView}
          variants={stagger(0.06)}
          className="lume-principles"
          style={{ listStyle: 'none', padding: 0, margin: 0, counterReset: 'lume-pr' }}
        >
          {principles.map((p, i) => (
            <motion.li
              key={p.id}
              variants={fadeUp}
              className="lume-card"
              whileHover={{ y: -3 }}
              transition={{ duration: 0.2, ease: [0.2, 0.8, 0.2, 1] }}
              style={{ counterIncrement: 'lume-pr' }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent: 'space-between',
                  gap: '0.75rem',
                  marginBottom: '0.85rem',
                }}
              >
                <PrincipleIcon iconKey={p.iconKey} />
                <span
                  aria-hidden="true"
                  style={{
                    fontFamily: 'var(--font-display)',
                    fontWeight: 700,
                    fontSize: '0.85rem',
                    color: 'var(--color-fg-subtle)',
                  }}
                >
                  {String(i + 1).padStart(2, '0')}
                </span>
              </div>
              <h3
                style={{
                  fontFamily: 'var(--font-display)',
                  fontSize: '1.05rem',
                  fontWeight: 600,
                  lineHeight: 1.3,
                  margin: 0,
                  marginBottom: '0.5rem',
                }}
              >
                {p.title}
              </h3>
              <p
                style={{
                  margin: 0,
                  fontSize: '0.9rem',
                  color: 'var(--color-fg-muted)',
                  lineHeight: 1.55,
                }}
              >
                {p.body}
              </p>
            </motion.li>
          ))}
        </motion.ol>
      </div>
    </section>
  );
}
